// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title_Sing_ing {\n  color: #ffffff;\n  font-size: 100px;\n  font-style: italic;\n  font-family: \"Rastella\";\n}", "",{"version":3,"sources":["webpack://./src/pages/sign-in/styles.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AACF","sourcesContent":[".title_Sing_ing{\n  color: #ffffff;\n  font-size: 100px;\n  font-style: italic;\n  font-family: \"Rastella\"\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
